import { motion } from 'framer-motion';
import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../../../App';
import { ReactComponent as UnlockIcon } from '../../../Assets/JFS/UnlockIcon.svg';
import { FlowType } from '../../../Utils/constants';
import { EVENTCODES, pushEventToParent } from '../../../Utils/eventUtils';
import { ROUTES } from '../../../Utils/routes';
import { AASTEPS } from '../../AA';
import Header from './Header';
import cardStyles from './JFSNudgeLinkAccounts.module.css';
import styles from './index.module.css';

const BENEFITS = [
  'Daily insights on where your money goes',
  'Spends, savings and investments in one place',
  'Personalised nudges to help you save and invest better',
];

const JFSNudgeLinkAccounts: React.FC = () => {
  const navigate = useNavigate();
  const {
    setCurrentRoute,
    setCurrentFlowType,
    setAAInternalStep,
    setIsLoading,
    setBackButtonHandler,
  } = useContext<any>(AppContext);

  const windowHeight = typeof window !== 'undefined' ? window.innerHeight : 0;

  const goToWelcome = () => {
    setCurrentRoute(ROUTES.JFS_WELCOME);
    navigate(ROUTES.JFS_WELCOME);
  };

  const handleLinkBankAccount = () => {
    pushEventToParent({
      eventCode: EVENTCODES.NUDGES_LINK_ACCOUNTS_BANK_LINK_CLICKED,
    });
    setAAInternalStep(AASTEPS.AA_JOURNEY);
    setCurrentFlowType(FlowType.BANKS);
    setCurrentRoute(ROUTES.AAJOURNEY);
  };

  useEffect(() => {
    pushEventToParent({ eventCode: EVENTCODES.NUDGES_LINK_ACCOUNTS_VIEWED });
    setIsLoading(false);
    setBackButtonHandler(() => {
      return () => {
        goToWelcome();
      };
    });
  }, []);

  const containerStyle = {
    height: `${windowHeight}px`,
    maxHeight: `${windowHeight}px`,
  } as React.CSSProperties;

  return (
    <div className={styles.nudgeStackWrapper} style={containerStyle}>
      <div className={styles.nudgeStackContainer}>
        <Header
          title='Insights'
          numberOfNudgesLeft={0}
          currentNudgeIndex={0}
          onReset={() => {}}
          onUndo={() => {}}
          onClose={goToWelcome}
          showNumberOfNudgesLeft={false}
          showCloseButton
          link=''
        />

        <div className={styles.cardsContainer}>
          <div className={styles.cardWrapper}>
            <motion.div
              className={cardStyles.linkAccountsCard}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.3 }}
            >
              <div className={cardStyles.content}>
                <div className={cardStyles.iconContainer}>
                  <UnlockIcon color='#004566' />
                </div>

                <div className={cardStyles.textContent}>
                  <h2 className={cardStyles.heading}>
                    Link bank accounts to see your insights
                  </h2>
                  <p className={cardStyles.description}>
                    We need at least one linked account before we can build your
                    daily insights.
                  </p>
                </div>

                <div className={cardStyles.benefitList}>
                  {BENEFITS.map((benefit) => (
                    <div className={cardStyles.benefitItem} key={benefit}>
                      <span className={cardStyles.benefitBullet} />
                      <span className={cardStyles.benefitText}>{benefit}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className={cardStyles.actions}>
                <motion.button
                  className={cardStyles.primaryButton}
                  onClick={handleLinkBankAccount}
                  whileTap={{ scale: 0.95 }}
                >
                  <span>Link bank account</span>
                </motion.button>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JFSNudgeLinkAccounts;
